import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "../../tax-corporation";

const schema = z.object({
	managerInformation: ManagerInformationModel.model,
	sumOfVisit: z.number(),
	sumOfVisitAndCounsel: z.number(),
	sumOfEtc: z.number()
});

const model = schema.transform((values) => ({
	...values
}));

export const ManagerVisitHistoryModel = {schema, model};
export type IManagerVisitHistoryModel = z.infer<typeof ManagerVisitHistoryModel.model>;
export const DEFAULT_MANAGER_VISIT_HISTORY: IManagerVisitHistoryModel = {
	managerInformation: DEFAULT_MANAGER_INFORMATION,
	sumOfVisit: 0,
	sumOfVisitAndCounsel: 0,
	sumOfEtc: 0
};
